import { AuxiliaryProcessSectionDataP714 } from './Data/P714/P714.data';

export const selectAuxiliaryProcessSectionData = (selectedTag, formName, formData) => {
    let filterViewData = { rows: [] };
    if ((['P7-14', 'P7-18', 'P7-29', 'P8-12.1', 'P7-30', 'P6-27', 'P6-31']).includes(formName)) {
        filterViewData = AuxiliaryProcessSectionDataP714(formData, formName);
    }
    return filterViewData;
};
